import { createFileRoute } from "@tanstack/react-router";
import { AppNav } from "@/components/AppNav";
import { PriceReferenceBody } from "@/components/PriceReferenceBody";
import { SITE_URL, priceReferenceDatasetJsonLd } from "@/lib/seo-jsonld";
import { teaser } from "@/lib/price-reference";

export const Route = createFileRoute("/tabela")({
  head: () => {
    const url = `${SITE_URL}/tabela/`;
    // Keyword first, brand second: the series name is the masthead on the page
    // itself, so the title tag can spend its weight on the query instead.
    const title = "Tabela de preço do carro blindado usado — Busca Blindados";
    const description =
      "Quanto custa um blindado usado: piso, mediana e teto do preço pedido por modelo, versão e ano. A FIPE não cobre blindagem — esta tabela cobre. Atualizada todo mês.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { name: "robots", content: "index,follow" },
        { property: "og:type", content: "website" },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: url },
      ],
      links: [{ rel: "canonical", href: url }],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            priceReferenceDatasetJsonLd({
              url,
              editionMonth: teaser.editionMonth,
              generatedAt: teaser.generatedAt,
              minN: teaser.minN,
            }),
          ),
        },
      ],
    };
  },
  component: TabelaPage,
});

function TabelaPage() {
  return (
    <div className="min-h-screen text-foreground">
      <AppNav />
      <PriceReferenceBody />
    </div>
  );
}
